import ChatWindowDropZoneMultifile, { ChatWindowDropZoneMultifileRef } from '@/chat-common/components/ChatWindowDropZoneMultifile'
import NewChatSkills from './new-chat-skills'

interface NewChatUXProps {
  conversationId: string
  chatWindowDropZoneMultifileRef: React.MutableRefObject<ChatWindowDropZoneMultifileRef | null>
  chatWindowTemplateDropZoneMultifileRef: React.MutableRefObject<ChatWindowDropZoneMultifileRef | null>
  onFilesAccepted?: (files: File[]) => void
  showVisibleDropZone?: boolean
}

/**
 * New Chat UX
 * UX components unique to the chat window when this is a new chat (no events)
 * @returns
 */
export default function NewChatUX(props: NewChatUXProps) {
  const { conversationId, chatWindowDropZoneMultifileRef, chatWindowTemplateDropZoneMultifileRef, onFilesAccepted, showVisibleDropZone = true } = props

  return (
    <div className="flex flex-col justify-start pt-4 pb-5">
      <NewChatSkills conversationId={conversationId} />
      {onFilesAccepted ? (
        <>
          {showVisibleDropZone && (
            <ChatWindowDropZoneMultifile
              hideDropZoneUI={false} // Show the drop zone UI on this New Chat UX
              chatId={conversationId}
              onFilesAccepted={onFilesAccepted}
            />
          )}
          {/* Keep the legacy ref on a hidden dropzone so the old Upload Files menu can still open the legacy picker. */}
          <ChatWindowDropZoneMultifile ref={chatWindowDropZoneMultifileRef} hideDropZoneUI={true} chatId={conversationId} />
        </>
      ) : (
        <ChatWindowDropZoneMultifile ref={chatWindowDropZoneMultifileRef} hideDropZoneUI={!showVisibleDropZone} chatId={conversationId} />
      )}
      <ChatWindowDropZoneMultifile
        ref={chatWindowTemplateDropZoneMultifileRef}
        hideDropZoneUI={true}
        chatId={conversationId}
        isSingleFileLimit={true}
        isTemplateMode={true}
      />
    </div>
  )
}
